<template>
    <div>
        <el-dialog
            title="发放昵称框"
            :visible.sync="dialogNickVisible"
            :append-to-body="true"
            width="400px"
            :center="true"
            top="200px"
            :close-on-click-modal="false"
            :before-close="() => closeNickDialog()"
        >
            <el-form
                :model="NickForm"
                :rules="rules"
                ref="NickForm"
                label-width="100px"
            >
                <el-form-item label="选择背景墙" prop="nick_id">
                    <el-select v-model="NickForm.nick_id" placeholder="请选择背景墙" filterable clearable @change="get_img" class="nick_c">
                        <el-option
                            v-for="item in nick_arr"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div style="text-align: center;"><img :src="img" height="200px" v-if="img" style="border-radius: 10px;"></div>
            <div slot="footer">
                <el-button type="success" plain @click="submit('NickForm')" >发 放</el-button>
                <el-button plain @click="closeNickDialog()">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { UserGiveNickRequest } from '@/network/user.js'
import { ShopNickListRequest,ShopNickDetailsRequest } from '@/network/shop/ShopNick.js'

export default {
    name:'',
    data(){
        return {
            NickForm: {
                nick_id: ''
            },
            rules: {
                nick_id: [
                    {
                        required: true,
                        message: '请选择昵称框',
                        trigger: 'blur',
                    },
                ]
            },
            nick_arr: [],
            img: ''
        }
    },
    computed:{},
    methods:{
        closeNickDialog() {
            this.NickForm = {
                nick_id: ''
            }
            this.img = ''
            this.$emit('ExitNickDialog')
        },
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }

                this.NickForm.user_id = this.id
                UserGiveNickRequest(this.NickForm)
                    .then((s) => {
                        if (s.status === 0) {
                            this.$message.success('昵称框发放成功!')
                            this.$emit('refresh')
                            this.closeNickDialog()
                        } else {
                            this.$message.error(s.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            })
        },
        get_all_nick() {
            ShopNickListRequest()
                .then((s) => {
                    if (s.status === 0) {
                        this.nick_arr = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.$message.error(err)
                })
        },
        get_img(v) {
            if(v) {
                ShopNickDetailsRequest(v)
                .then((s) => {
                    if (s.status === 0) {
                        this.img = s.result.data.picture[0]['url']
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
            }

            this.img = ''
        }
    },
    filters:{},
    props:{
        dialogNickVisible: {
            type: Boolean,
            default() {
                return false
            }
        },
        id: {
            type: Number,
            default() {
                return 0
            }
        }
    },
    created(){
        this.get_all_nick()
    },
    beforeDestroy(){},
    mounted(){},
    updated(){},
    components:{},
    watch:{}
}
</script>

<style lang='less' scoped>
</style>